/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_material_equalize_custom': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<defs><path pid="0" d="M4 6h2.667V0H4v6zM0 7.333h2.667V4.667H0v2.666zm8-4V8h2.667V3.333H8z" id="svgicon_icon_material_equalize_custom_a"/><path pid="1" d="M4 4.667h2.667V0H4v4.667zm-4 0h2.667V1.333H0v3.334zM8 2v2.667h2.667V2H8z" id="svgicon_icon_material_equalize_custom_c"/></defs><g _fill="none" fill-rule="evenodd"><g transform="translate(.667 .667)"><mask id="svgicon_icon_material_equalize_custom_b" _fill="#fff"><use xlink:href="#svgicon_icon_material_equalize_custom_a"/></mask><g opacity=".5" mask="url(#svgicon_icon_material_equalize_custom_b)"><path pid="2" _fill="#FFF" d="M-2.667-2.667h16v16h-16z"/></g></g><g transform="translate(.667 6.667)"><mask id="svgicon_icon_material_equalize_custom_d" _fill="#fff"><use xlink:href="#svgicon_icon_material_equalize_custom_c"/></mask><g mask="url(#svgicon_icon_material_equalize_custom_d)"><path pid="3" _fill="#FFF" d="M-2.667-8.667h16v16h-16z"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_material_equalize_custom.js